import { MY_ASTER_CATEGORY, PAGE_NAME } from '../../Constants/analytics';
import moment from 'moment';
import {
  convertTimeToHHMMSS,
  formatDateToYearMonthDate,
  convertUtcToGst,
  formatYearMonthDateTime,
  convertDateToServer,
} from '../../Utility/date-utils';
import { ADJUST_EVENT_TOKENS, SCREEN_NAME, SLOT_STATUS } from '../../Utility/constants';
import { breadCrumbDecoder } from '../../Utility/common-utils';
import {
  sendSmAddPaymentInfoInitiated,
  sendSmAddPaymentInfoStatus,
  sendSmAppointModeChange,
  sendSmBeginCheckoutVc,
  sendSmBookAppointmentClick,
  sendSmBookFollowUpClick,
  sendSmCancelAppointment,
  sendSmChangeFacilityClick,
  sendSmCheckAppointmentDetailsClick,
  sendSmConfirmAppointment,
  sendSmDoctorCardClick,
  sendSmDoctorDetailsTabClick,
  sendSmDoctorSpecialityClick,
  sendSmFilterClick,
  sendSmGlobalButtonClick,
  sendSmPaginationDoctors,
  sendSmRebookConsultationClick,
  sendSmRescheduleAppointment,
  sendSmSelectFacility,
  sendSmSlotSelection,
  sendSmSortBy,
  sendSmViewAppointmentDetails,
  sendSmViewDoctorDetails,
} from './BookingFunnel-smartlook-events';
import { sendAdjustIntiateChekout } from '../../Utility/Adjust';
import { dataLayerSendEvent as sendEventData } from '../../Utility/analytics-utils';

export const dataLayerSendEvent = (eventName, data) => {
  sendEventData(eventName, data);
};

export const globalButtonClick = (buttonName, location, myAsterCategory) => {
  const itemData = {
    button_name: buttonName,
    button_location: location,
    myaster_category: myAsterCategory || MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('global_button_click', itemData);
  sendSmGlobalButtonClick('global_button_click', itemData);
};

export const doctorSpecialityClick = (screenName, pageType, pageId = '', speciality, sectionName, referrerPage) => {
  const getScreenName = () => {
    if (screenName === 'Aster Core Home') {
      return 'asco homepage';
    } else if (screenName === 'Tele Consult Home') {
      return 'doctor consult homepage';
    } else if (screenName === 'speciality list') {
      return 'speciality list';
    } else {
      return screenName.toLowerCase();
    }
  };

  const getReferrerPage = () => {
    if (referrerPage === 'Aster Core Home') {
      return 'asco homepage';
    } else if (referrerPage === 'Tele Consult Home') {
      return 'doctor consult homepage';
    } else if (referrerPage === 'speciality listing page') {
      return 'speciality listing page';
    } else {
      return referrerPage.toLowerCase();
    }
  };

  const itemData = {
    screen_name: getScreenName(),
    page_type: pageType,
    page_id: pageId,
    speciality: speciality?.toLowerCase(),
    section_name: sectionName,
    referrer_page: getReferrerPage(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('doctor_speciality_click', itemData);
  sendSmDoctorSpecialityClick('doctor_speciality_click', itemData);
};

export const doctorCardClick = (details, referrerPage, sectionName = '', pageId = '') => {
  const getScreenName = () => {
    if (referrerPage === '/doctor-consultation') {
      return 'doctor consult homepage';
    } else if (referrerPage === 'clinic detail page') {
      return `${details?.facilityDetails?.[0]?.facilityName}`;
    } else {
      return 'asco homepage';
    }
  };

  const getReferrerPage = () => {
    if (referrerPage === '/doctor-consultation') {
      return 'doctor consult homepage';
    } else if (referrerPage === 'clinic detail page') {
      return 'clinic details page';
    } else {
      return 'asco homepage';
    }
  };


  const getPageType = () => {
    if (referrerPage === 'clinic detail page') {
      return PAGE_NAME?.CDP;
    } else {
      return PAGE_NAME?.ASCO;
    }
  };

  const getFacilityType = () => {
    if (details?.facilityDetails?.[0]?.facilityType === 'Clinic') {
      return 'clinic_lt';
    } else if (details?.facilityDetails?.[0]?.facilityType === 'Hospital') {
      return 'hospital';
    }
  };

  const itemData = {
    screen_name: getScreenName(),
    page_type: getPageType(),
    page_id: pageId,
    speciality: details?.specialization,
    selection: 'doctor card',
    section_name: sectionName,
    doctor_name: details?.name,
    referrer_page: getReferrerPage(),
    consultation_inperson: !!(details?.consultation?.length > 0 || details?.consultation?.includes('offline')),
    consultation_video: !!details?.consultation?.includes('online'),
    distance: details?.facilityDetails?.[0]?.distance,
    facility_name: details?.facilityDetails?.[0]?.facilityName,
    facility_type: getFacilityType(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    earliest_inperson_slot_availability: details?.nextAvailableAt
      ? formatYearMonthDateTime(details?.nextAvailableAt)
      : '',
    earliest_video_slot_availability: details?.nextAvailableAtForOnline
      ? formatYearMonthDateTime(details?.nextAvailableAtForOnline)
      : '',
  };
  dataLayerSendEvent('doctor_card_click', itemData);
  sendSmDoctorCardClick('doctor_card_click', itemData);
};

export const doctorCardClickList = (details, selection, router) => {
  const getScreenName = () => {
    if (router?.query !== undefined) {
      if (
        router?.query?.type === 'facilitydetail' ||
        router?.query?.type === 'detailhome' ||
        router?.query?.type === 'detailall'
      ) {
        return `${breadCrumbDecoder(router?.query?.facility)?.toLowerCase()}`;
      } else if (router?.query?.type === 'newDoctor') {
        return 'new doctor listing';
      } else if (router?.query?.type === 'home') {
        return 'doctor search results';
      } else {
        return `${breadCrumbDecoder(router?.query?.speciality)?.toLowerCase()}`;
      }
    }
  };

  const getPageType = () => {
    if (router?.query !== undefined) {
      if (router?.query?.type === 'home') {
        return PAGE_NAME?.SRP;
      } else {
        return PAGE_NAME?.DLP;
      }
    }
  };

  const getFacilityType = () => {
    if (details?.facilityDetails?.[0]?.clinicType === 'Clinic') {
      return 'clinic_lt';
    } else if (details?.facilityDetails?.[0]?.clinicType === 'Hospital') {
      return 'hospital';
    }
  };

  const Selection = () => {
    if (selection === 'View more') {
      return 'view more link';
    } else if (selection === 'VIDEO') {
      return 'video card';
    } else if (selection === 'IN_PERSON') {
      return 'in person card';
    } else {
      return 'doctor card';
    }
  };

  const getPageId = () => {
    return router?.query?.type === 'facilitydetail' ||
      router?.query?.type === 'detailhome' ||
      router?.query?.type === 'detailall'
      ? router?.query?.clinic
      : '';
  };

  const itemData = {
    screen_name: getScreenName(),
    page_type: getPageType(),
    page_id: getPageId(),
    speciality: details?.specialization,
    selection: Selection(),
    section_name: '',
    doctor_name: details?.name,
    referrer_page: PAGE_NAME?.DLP,
    consultation_inperson: !!(details?.consultation?.length > 0 || details?.consultation?.includes('offline')),
    consultation_video: !!details?.consultation?.includes('online'),
    distance: `${details?.facilityDetails?.[0]?.distanceInKm} kms`,
    facility_name: details?.facilityDetails?.[0]?.name,
    facility_type: getFacilityType(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    earliest_inperson_slot_availability: details?.facilityDetails?.[0]?.offlineSlot
      ? formatYearMonthDateTime(details?.facilityDetails?.[0]?.offlineSlot?.startTime)
      : '',
    earliest_video_slot_availability: details?.availableOnlineSlot
      ? formatYearMonthDateTime(details?.availableOnlineSlot?.startTime)
      : '',
  };
  dataLayerSendEvent('doctor_card_click', itemData);
  sendSmDoctorCardClick('doctor_card_click', itemData);
};

export const doctorConsultFilterClick = (router, selection, filterItem, filter) => {
  const filterSelection = () => (selection === -1 ? 'filter enabled' : 'filter disabled');

  const getScreenName = () => {
    if (router?.query !== undefined) {
      if (router?.query?.type === 'home') {
        return 'doctor search results';
      } else if (router?.query?.type === 'newDoctor') {
        return 'new doctor listing';
      } else if (
        router?.query?.type === 'detailhome' ||
        router?.query?.type === 'facilitydetail' ||
        router?.query?.type === 'detailall'
      ) {
        return `${breadCrumbDecoder(router?.query?.facility)?.toLowerCase()}`;
      } else {
        return `${breadCrumbDecoder(router?.query?.speciality)?.toLowerCase()}`;
      }
    }
  };

  const getPageType = () => {
    if (router?.query?.type === 'home') {
      return PAGE_NAME?.SRP;
    } else {
      return PAGE_NAME?.DLP;
    }
  };

  const getPageId = () => {
    return router?.query?.type === 'facilitydetail' ||
      router?.query?.type === 'detailhome' ||
      router?.query?.type === 'detailall'
      ? router?.query?.clinic
      : '';
  };

  const itemData = {
    screen_name: getScreenName(),
    page_type: getPageType(),
    page_id: getPageId(),
    selection: filterSelection(),
    filter_value: filter?.displayName?.toLowerCase(),
    filter_category: filterItem?.name?.toLowerCase(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('filter_click', itemData);
  sendSmFilterClick('filter_click', itemData);
};

export const doctorConsultDynamicFilter = (router, filterSelection, filterType) => {
  const getScreenName = () => {
    if (router?.query !== undefined) {
      if (router?.query?.type === 'home') {
        return 'doctor search results';
      } else if (router?.query?.type === 'newDoctor') {
        return 'new doctor listing';
      } else if (
        router?.query?.type === 'detailhome' ||
        router?.query?.type === 'facilitydetail' ||
        router?.query?.type === 'detailall'
      ) {
        return `${breadCrumbDecoder(router?.query?.facility)?.toLowerCase()}`;
      } else {
        return `${breadCrumbDecoder(router?.query?.speciality)?.toLowerCase()}`;
      }
    }
  };

  const getPageType = () => {
    if (router?.query?.type === 'home') {
      return PAGE_NAME?.SRP;
    } else {
      return PAGE_NAME?.DLP;
    }
  };

  const getPageId = () => {
    return router?.query?.type === 'facilitydetail' ||
      router?.query?.type === 'detailhome' ||
      router?.query?.type === 'detailall'
      ? router?.query?.clinic
      : '';
  };

  const getFilterValue = () => {
    if (filterType === 'DOCTOR') {
      return 'doctors';
    } else if (filterType === 'FACILITY') {
      return 'facilities';
    } else if (filterType === 'PACKAGES') {
      return 'health packages';
    } else if (filterType === 'TODAY') {
      return 'available today';
    } else if (filterType === 'VIDEO') {
      return 'video consultation';
    }
  };

  const getFilterCategory = () => {
    if (filterType === 'DOCTOR') {
      return 'practitioner';
    } else if (filterType === 'FACILITY') {
      return 'facility';
    } else if (filterType === 'PACKAGES') {
      return 'packages';
    } else if (filterType === 'TODAY' || 'VIDEO') {
      return 'availability';
    }
  };

  const itemData = {
    screen_name: getScreenName(),
    page_type: getPageType(),
    page_id: getPageId(),
    selection: filterSelection,
    filter_value: getFilterValue(),
    filter_category: getFilterCategory(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('filter_click', itemData);
  sendSmFilterClick('filter_click', itemData);
};

export const doctorConsultSortBy = (screenName, pageType, pageId = '', value) => {
  const getValue = () => {
    if (value === 'location-asc') {
      return 'distance';
    } else if (value === 'name-asc') {
      return 'name';
    } else {
      return value.toLowerCase();
    }
  };
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    page_id: pageId,
    option: getValue(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('sort_by', itemData);
  sendSmSortBy('sort_by', itemData);
};

export const paginationDoctors = (screenName = '', pageType, pageId = '', selection) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    page_id: pageId,
    selection: selection,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('pagination_doctors', itemData);
  sendSmPaginationDoctors('pagination_doctors', itemData);
};

export const paginationEvent = (page, router, facilityName = '') => {
  const specialityName = breadCrumbDecoder(router?.query?.speciality);
  const facilityId = router?.query?.clinic;
  const query = breadCrumbDecoder(router?.query?.search);
  const facility_name = decodeURIComponent(facilityName);

  if (specialityName) {
    paginationDoctors(`${specialityName}`, PAGE_NAME?.DLP, '', page);
  } else if (facilityName) {
    paginationDoctors(`${facility_name}`, PAGE_NAME?.DLP, `${facilityId}`, page);
  } else if (query) {
    paginationDoctors('doctor search result', PAGE_NAME?.SRP, '', page);
  } else {
    paginationDoctors('new doctor listing', PAGE_NAME?.DLP, '', page);
  }
};

export const viewDoctorDetails = ({ details, facilityName, facilityDistance, slot, referrerPage }) => {
  const title = details?.attributes?.title?.toLowerCase();
  const fullName = details?.attributes?.fullName?.toLowerCase();
  const screenName = `${title} ${fullName}`;
  const doctorName = `${details?.attributes?.title}. ${details?.attributes?.fullName}`;

  const slotAvailable = () => {
    if (slot?.appointmentSlots?.length > 0) {
      if (slot?.appointmentSlots?.some((slot) => slot?.statusText === SLOT_STATUS?.AVAILABLE)) {
        return `${slot?.selectedDate}`;
      } else {
        return 'all slots are booked';
      }
    } else if (slot?.appointmentSlots?.length === 0) {
      return 'no slots available';
    }
  };

  const getFacilityType = () => {
    if (details?.attributes?.facilityList?.[0]?.facilityType === 'Clinic') {
      return 'clinic_lt';
    } else if (details?.attributes?.facilityList?.[0]?.facilityType === 'Hospital') {
      return 'hospital';
    }
  };

  const itemData = {
    screen_name: screenName,
    page_id: details?.vcpId,
    page_type: PAGE_NAME?.DDP,
    speciality: details?.attributes?.primarySpeciality,
    doctor_name: doctorName,
    referrer_page: referrerPage?.toLowerCase(),
    consultation_inperson:
      details?.attributes?.consultationType === 'IN-PERSON' || details?.attributes?.consultationType === 'BOTH',
    consultation_video:
      details?.attributes?.consultationType === 'ONLINE' || details?.attributes?.consultationType === 'BOTH',
    slot_availability: slotAvailable(),
    distance: facilityDistance,
    facility_name: facilityName,
    facility_type: getFacilityType(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('view_doctor_details', itemData);
  sendSmViewDoctorDetails('view_doctor_details', itemData);
};

export const doctorDetailsTabClick = (accTitle, details) => {
  const title = details?.attributes?.title?.toLowerCase();
  const fullName = details?.attributes?.fullName?.toLowerCase();
  const screenName = `${title} ${fullName}`;
  const itemData = {
    screen_name: screenName,
    page_id: details?.vcpId,
    page_type: PAGE_NAME?.DDP,
    tab_name: accTitle?.toLowerCase(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('doctor_details_tabs_click', itemData);
  sendSmDoctorDetailsTabClick('doctor_details_tab_click', itemData);
};

export const appointmentModeChange = (details, appointmentMode, defaultAppointment, facilityName) => {
  const title = details?.attributes?.title?.toLowerCase();
  const fullName = details?.attributes?.fullName?.toLowerCase();
  const screenName = `${title} ${fullName}`;
  const doctorName = `${details?.attributes?.title}. ${details?.attributes?.fullName}`;
  const defaultAppointmentType = defaultAppointment === 'IN_PERSON' ? 'in-person consultation' : 'video consultation';
  const appointmentType = appointmentMode === 'IN_PERSON' ? 'in-person consultation' : 'video consultation';

  const getFacilityType = () => {
    if (details?.attributes?.facilityList?.[0]?.facilityType === 'Clinic') {
      return 'clinic_lt';
    } else if (details?.attributes?.facilityList?.[0]?.facilityType === 'Hospital') {
      return 'hospital';
    }
  };

  const itemData = {
    screen_name: screenName,
    page_type: PAGE_NAME?.DDP,
    page_id: details?.vcpId,
    speciality: details?.attributes?.primarySpeciality,
    default_appointment: defaultAppointmentType,
    appointment_mode: appointmentType,
    doctor_name: doctorName,
    facility_name: facilityName,
    facility_type: getFacilityType(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('appointment_mode_changed', itemData);
  sendSmAppointModeChange('appointment_mode_changed', itemData);
};

export const doctorSlotSelection = (details, facilityName, facilityDistance, appointmentMode, slot, referrerPage, slotCount, selectedDate) => {
  const title = details?.attributes?.title?.toLowerCase();
  const fullName = details?.attributes?.fullName?.toLowerCase();
  const screenName = `${title} ${fullName}`;
  const doctorName = `${details?.attributes?.title}. ${details?.attributes?.fullName}`;
  const timeStamp = convertUtcToGst(slot?.startTime);
  const appointmentType = appointmentMode === 'IN_PERSON' ? 'in-person consultation' : 'video consultation';

  const getFacilityType = () => {
    if (details?.attributes?.facilityList?.[0]?.facilityType === 'Clinic') {
      return 'clinic_lt';
    } else if (details?.attributes?.facilityList?.[0]?.facilityType === 'Hospital') {
      return 'hospital';
    }
  };

  const getAppointmentDate = () => {
    if (slot !== '' && slot !== undefined) {
      return formatDateToYearMonthDate(slot?.startTime);
    } else {
      return selectedDate;
    }
  };

  const itemData = {
    screen_name: screenName,
    page_type: PAGE_NAME?.DDP,
    page_id: details?.vcpId,
    speciality: details?.attributes?.primarySpeciality,
    appointment_mode: appointmentType,
    doctor_name: doctorName,
    distance: facilityDistance,
    referrer_page: referrerPage?.toLowerCase(),
    facility_name: facilityName,
    facility_type: getFacilityType(),
    appointment_date: getAppointmentDate(),
    appointment_time: convertTimeToHHMMSS(timeStamp),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    slot_availability: slotCount,
  };
  dataLayerSendEvent('slot_selection', itemData);
  sendSmSlotSelection('slot_selection', itemData);
};

export const changeFacilityClick = (details, facilityName, facilityType, appointmentMode) => {
  const title = details?.attributes?.title?.toLowerCase();
  const fullName = details?.attributes?.fullName?.toLowerCase();
  const screenName = `${title} ${fullName}`;
  const doctorName = `${details?.attributes?.title}. ${details?.attributes?.fullName}`;
  const appointmentType = appointmentMode === 'IN_PERSON' ? 'in-person consultation' : 'video consultation';

  const itemData = {
    screen_name: screenName,
    page_id: details?.vcpId,
    page_type: PAGE_NAME?.DDP,
    speciality: details?.attributes?.primarySpeciality,
    appointment_mode: appointmentType,
    doctor_name: doctorName,
    facility_name: facilityName,
    facility_type: facilityType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('change_facility_click', itemData);
  sendSmChangeFacilityClick('change_facility_click', itemData);
};

export const selectFacility = (details, facilityName, facilityType, appointmentMode) => {
  const title = details?.attributes?.title?.toLowerCase();
  const fullName = details?.attributes?.fullName?.toLowerCase();
  const screenName = `${title} ${fullName}`;
  const doctorName = `${details?.attributes?.title}. ${details?.attributes?.fullName}`;
  const appointmentType = appointmentMode === 'IN_PERSON' ? 'in-person consultation' : 'video consultation';

  const getFacilityType = () => {
    if (facilityType === 'Clinic') {
      return 'clinic_lt';
    } else if (facilityType === 'Hospital') {
      return 'hospital';
    }
  };

  const itemData = {
    screen_name: screenName,
    page_id: details?.vcpId,
    page_type: PAGE_NAME?.DDP,
    speciality: details?.attributes?.primarySpeciality,
    appointment_mode: appointmentType,
    doctor_name: doctorName,
    facility_name: facilityName,
    facility_type: getFacilityType(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('select_facility', itemData);
  sendSmSelectFacility('select_facility', itemData);
};

export const beginCheckoutVc = (data) => {
  const timeStamp = convertUtcToGst(data?.start);
  const practitioner = data?.participant?.find((x) => x?.actor?.type === 'Practitioner');
  const location = data?.participant?.find((x) => x?.actor?.type === 'Location');
  const screenName = practitioner?.actor?.display;
  const formattedScreenName = screenName ? screenName?.replace('Dr. ', 'dr ')?.toLowerCase() : '';
  const facilityType = location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString;

  const getFacilityType = () => {
    return facilityType === 'clinic' ? 'clinic_lt' : facilityType === 'hospital' ? 'hospital' : null;
  };

  const itemData = {
    screen_name: formattedScreenName,
    page_type: PAGE_NAME?.DDP,
    page_id: practitioner?.actor?.reference,
    facility_type: getFacilityType(),
    facility_name: location?.actor?.display,
    appointment_mode:
      data?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString === 'Online'
        ? 'video consultation'
        : 'in-person consultation',
    appointment_time: convertTimeToHHMMSS(timeStamp),
    appointment_date: formatDateToYearMonthDate(data?.start),
    speciality: data?.extension?.find((x) => x?.url === 'practitionerDepartment')?.valueString,
    doctor_name: screenName,
    doctor_id: practitioner?.actor?.reference,
    distance: location?.actor?.extension?.find((itm) => itm?.url === 'distance')?.valueString,
    insurance_coverage: data?.extension?.find((x) => x?.url === 'insuranceCovered')?.valueBoolean,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('begin_checkout_vc', itemData);
  sendSmBeginCheckoutVc('begin_checkout_vc', itemData);
  sendAdjustIntiateChekout(ADJUST_EVENT_TOKENS?.INITIATE_CHECKOUT, itemData?.speciality);
};

export const bookAppointmentClick = (details, paymentType, securePoints = '') => {
  const locationDetails = details?.participant?.find((x) => x?.actor?.type === 'Location');
  const practitionerDetails = details?.participant?.find((x) => x?.actor?.type === 'Practitioner');
  const paymentAmount = details?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString;
  const paidAmount = isNaN(paymentAmount) ? 0 : parseInt(paymentAmount);
  const timeStamp = convertUtcToGst(details?.start);
  const facilityType = locationDetails?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString;

  const getFacilityType = () => {
    return facilityType === 'clinic' ? 'clinic_lt' : facilityType === 'hospital' ? 'hospital' : null;
  };

  const getPaymentMethod = () => {
    if (details?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance') {
      return 'pay via insurance';
    } else {
      return 'self-pay';
    }
  };

  const itemData = {
    screen_name: SCREEN_NAME?.APPOINTMENT_CHECKOUT,
    facility_name: locationDetails?.actor?.display,
    facility_type: getFacilityType(),
    payment_type: paymentType?.toLowerCase(),
    payment_method: getPaymentMethod(),
    payment_amount: paidAmount,
    insurance_provider:
      details?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance'
        ? details?.extension?.find((x) => x?.url === 'insuranceName')?.valueString
        : '',
    insurance_network: details?.extension?.find((x) => x?.url === 'insuranceNetwork')?.valueString,
    insurance_coverage: !!details?.extension?.find((x) => x?.url === 'insuranceCovered')?.valueBoolean,
    secure_points_earned: Number(securePoints),
    appointment_mode:
      details?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString === 'In-Person'
        ? 'in-person consultation'
        : 'video consultation',
    appointment_time: convertTimeToHHMMSS(timeStamp),
    appointment_date: formatDateToYearMonthDate(details?.start),
    doctor_name: practitionerDetails?.actor?.display,
    doctor_id: practitionerDetails?.actor?.reference,
    speciality:
      details?.extension?.find((x) => x?.url === 'practitionerDepartment')?.valueString ||
      practitionerDetails?.actor?.extension?.find((itm) => itm?.url === 'practitionerDepartment')?.valueString,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    currency: 'AED',
  };
  dataLayerSendEvent('book_appointment_click', itemData);
  sendSmBookAppointmentClick('book_appointment_click', itemData);
};

export const addPaymentInfoConsult = (details, paymentType) => {
  const getPaymentMethod = () => {
    if (details?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance') {
      return 'pay via insurance';
    } else {
      return 'self-pay';
    }
  };

  const itemData = {
    screen_name: SCREEN_NAME?.APPOINTMENT_CHECKOUT,
    page_type: PAGE_NAME?.CP,
    booking_type: details?.extension?.find((x) => x?.url === 'isInstantGPAppointment')?.valueBoolean
      ? 'instant gp booking'
      : 'standard booking',
    payment_method: getPaymentMethod(),
    payment_type: paymentType?.toLowerCase(),
    payment_amount: Number(details?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString),
    currency: 'AED',
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('add_payment_info_initiated', itemData);
  sendSmAddPaymentInfoInitiated('add_payment_info_initiated', itemData);
};

export const addPaymentInfoStatus = (details, paymentType, paymentStatus, screenName) => {
  const bookingType = () => {
    if (details?.isInstantGPAppointment) {
      return 'instant gp booking';
    } else {
      return 'standard booking';
    }
  };

  const getPaymentMethod = () => {
    if (details?.payerType === 'Insurance') {
      return 'pay via insurance';
    } else {
      return 'self-pay';
    }
  };

  const itemData = {
    screen_name: screenName,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    booking_type: bookingType(),
    payment_amount: Number(details?.paymentAmount),
    currency: 'AED',
    payment_status: paymentStatus,
    payment_type: paymentType?.toLowerCase(),
    payment_method: getPaymentMethod(),
  };
  dataLayerSendEvent('add_payment_info_status', itemData);
  sendSmAddPaymentInfoStatus('add_payment_info_status', itemData);
};

export const confirmAppointment = (details, paymentType, securePoints = '') => {
  const getFacilityType = () => {
    return details?.facilityType === 'clinic' ? 'clinic_lt' : details?.facilityType === 'hospital' ? 'hospital' : null;
  };

  const getPaymentMethod = () => {
    if (details?.payerType === 'Insurance') {
      return 'pay via insurance';
    } else {
      return 'self-pay';
    }
  };

  const bookingType = () => {
    if (details?.isInstantGPAppointment) {
      return 'instant gp booking';
    } else {
      return 'standard booking';
    }
  };

  const getMemberType = () => {
    if (details?.patientIsPrimary) {
      return 'self member';
    } else {
      return 'family member';
    }
  };

  const itemData = {
    screen_name: SCREEN_NAME?.BOOKING_CONFIRMATION,
    page_type: PAGE_NAME?.CP,
    facility_name: details?.facilityName,
    facility_type: getFacilityType(),
    payment_type: paymentType?.toLowerCase(),
    payment_method: getPaymentMethod(),
    payment_amount: Number(details?.paymentAmount),
    payment_status: details?.paymentCompleted === 'true' ? 'paid' : 'unpaid',
    insurance_provider: details?.payerType === 'Insurance' ? details?.insuranceProvider : '',
    insurance_network: details?.insuranceNetwork,
    insurance_coverage: !!details?.isInsuranceCovered,
    secure_points_earned: Number(securePoints),
    appointment_status: details?.bookingStatus,
    currency: details?.currencyCode,
    appointment_mode: details?.consultationType?.toLowerCase(),
    appointment_time: convertTimeToHHMMSS(details?.appointmentTime),
    appointment_date: formatDateToYearMonthDate(details?.appointmentDate),
    booking_id: details?.bookingID,
    appointment_id: details?.bookingConfirmationId,
    booking_type: bookingType(),
    doctor_name: details?.doctorName,
    doctor_id: details?.doctorId,
    speciality: details?.doctorSpecialty,
    distance: details?.distance,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    visit_type: details?.visitType,
    member_type: getMemberType(),
    appointment_booking: 1,
  };
  dataLayerSendEvent('confirm_appointment', itemData);
  sendSmConfirmAppointment('confirm_appointment', itemData);
};

export const checkAppointmentDetailsClick = (details) => {
  const getFacilityType = () => {
    return details?.facilityType === 'clinic' ? 'clinic_lt' : details?.facilityType === 'hospital' ? 'hospital' : null;
  };

  const getBookingType = () => {
    if (details?.isInstantGPAppointment) {
      return 'instant gp booking';
    } else {
      return 'standard booking';
    }
  };

  const itemData = {
    screen_name: SCREEN_NAME?.BOOKING_CONFIRMATION,
    page_type: PAGE_NAME?.CP,
    facility_type: getFacilityType(),
    facility_name: details?.facilityName,
    referrer_page: 'booking confirmation page',
    appointment_status: details?.bookingStatus,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    appointment_date: formatDateToYearMonthDate(details?.appointmentDate),
    appointment_time: convertTimeToHHMMSS(details?.appointmentTime),
    appointment_mode: details?.consultationType?.toLowerCase(),
    booking_id: details?.bookingID,
    booking_type: getBookingType(),
    doctor_name: details?.doctorName,
    speciality: details?.doctorSpecialty,
    appointment_id: details?.bookingConfirmationId,
  };
  dataLayerSendEvent('check_appointment_details_click', itemData);
  sendSmCheckAppointmentDetailsClick('check_appointment_details_click', itemData);
};

export const viewAppointmentDetails = (details, referrerPage, type) => {
  const getFacilityType = () => {
    return details?.facilityType === 'clinic' ? 'clinic_lt' : details?.facilityType === 'hospital' ? 'hospital' : null;
  };

  const itemData = {
    screen_name: SCREEN_NAME?.APPOINTMENT_DETAIL,
    page_type: PAGE_NAME?.AP,
    facility_type: getFacilityType(),
    facility_name: details?.facilityName,
    referrer_page: referrerPage,
    appointment_status: details?.bookingStatus,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    appointment_mode: details?.consultationType?.toLowerCase(),
    appointment_time: convertTimeToHHMMSS(details?.appointmentTime),
    appointment_date: formatDateToYearMonthDate(details?.appointmentDate),
    booking_id: details?.bookingID,
    appointment_id: details?.bookingConfirmationId,
    speciality: details?.doctorSpecialty,
    doctor_name: details?.doctorName,
    visit_type: details?.visitType,
    type: type,
  };
  dataLayerSendEvent('view_appointment_details', itemData);
  sendSmViewAppointmentDetails('view_appointment_details', itemData);
};

export const cancelAppointmentVc = (data, reasonOfCancel) => {
  const practitioner = data?.appointmentDetails?.participant?.find((x) => x?.actor?.type === 'Practitioner');
  const location = data?.appointmentDetails?.participant?.find((x) => x?.actor?.type === 'Location');
  const paymentAmount = data?.appointmentDetails?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString;
  const timeStamp = convertUtcToGst(data?.appointmentDetails?.start);
  const paidAmount = isNaN(paymentAmount) ? 0 : parseInt(paymentAmount);
  const facilityType = location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString;

  const getFacilityType = () => {
    return facilityType === 'clinic' ? 'clinic_lt' : facilityType === 'hospital' ? 'hospital' : null;
  };

  const getPaymentMethod = () => {
    if (data?.appointmentDetails?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance') {
      return 'pay via insurance';
    } else {
      return 'self-pay';
    }
  };

  const itemData = {
    screen_name: SCREEN_NAME?.APPOINTMENT_DETAIL,
    page_type: PAGE_NAME?.AP,
    facility_type: getFacilityType(),
    facility_name: location?.actor?.display,
    referrer_page: PAGE_NAME?.ADP,
    payment_method: getPaymentMethod(),
    payment_amount: paidAmount,
    payment_status:
      data?.appointmentDetails?.extension?.find((x) => x?.url === 'paymentCompleted')?.valueString === 'true'
        ? 'paid'
        : 'unpaid',
    appointment_status: data?.appointmentDetails?.extension?.find((x) => x?.url === 'bookingStatus')?.valueString,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    appointment_date: formatDateToYearMonthDate(data?.appointmentDetails?.start),
    appointment_time: convertTimeToHHMMSS(timeStamp),
    appointment_mode:
      data?.appointmentDetails?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString === 'Online'
        ? 'video consultation'
        : 'in-person consultation',
    booking_id: data?.appointmentDetails?.extension?.find((x) => x?.url === 'hisSystem')?.valueIdentifier?.value,
    appointment_id: data?.appointmentId,
    booking_type: data?.appointmentDetails?.extension?.find((x) => x?.url === 'isInstantGPAppointment')?.valueBoolean
      ? 'instant gp booking'
      : 'standard booking',
    doctor_name: practitioner?.actor?.display,
    speciality: practitioner?.actor?.extension?.find((itm) => itm?.url === 'practitionerDepartment')?.valueString,
    reason_of_cancel: reasonOfCancel,
    visit_type: data?.appointmentDetails?.extension?.find((x) => x?.url === 'visitType')?.valueString,
  };
  dataLayerSendEvent('cancel_appointment', itemData);
  sendSmCancelAppointment('cancel_appointment', itemData);
};

export const rescheduleAppointmentVc = (details, data) => {
  const practitionerDetails = details?.participant?.find((x) => x?.actor?.type === 'Practitioner');
  const locationDetails = details?.participant?.find((x) => x?.actor?.type === 'Location');
  const screenName = practitionerDetails?.actor?.display;
  const formattedScreenName = screenName ? screenName?.replace('Dr. ', 'dr ')?.toLowerCase() : '';
  const paymentAmount = details?.extension?.find((x) => x?.url === 'paymentAmount')?.valueString;
  const oldTimeStamp = convertUtcToGst(details?.start);
  const newTimeStamp = convertUtcToGst(data?.start);
  const paidAmount = isNaN(paymentAmount) ? 0 : parseInt(paymentAmount);
  const facilityType = locationDetails?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString;

  const getFacilityType = () => {
    return facilityType === 'clinic' ? 'clinic_lt' : facilityType === 'hospital' ? 'hospital' : null;
  };

  const getPaymentMethod = () => {
    if (details?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance') {
      return 'pay via insurance';
    } else {
      return 'self-pay';
    }
  };

  const itemData = {
    screen_name: formattedScreenName,
    page_type: PAGE_NAME?.DDP,
    page_id: practitionerDetails?.actor?.reference,
    facility_type: getFacilityType(),
    facility_name: locationDetails?.actor?.display,
    referrer_page: PAGE_NAME?.ADP,
    payment_method: getPaymentMethod(),
    payment_amount: paidAmount,
    payment_status:
      details?.extension?.find((x) => x?.url === 'paymentCompleted')?.valueString === 'true' ? 'paid' : 'unpaid',
    insurance_provider:
      details?.extension?.find((x) => x?.url === 'payerType')?.valueString === 'Insurance'
        ? details?.extension?.find((x) => x?.url === 'insuranceName')?.valueString
        : '',
    insurance_network: details?.extension?.find((x) => x?.url === 'insuranceNetwork')?.valueString,
    currency: details?.extension?.find((x) => x?.url === 'currencyCode')?.valueString,
    appointment_date: formatDateToYearMonthDate(details?.start),
    appointment_time: convertTimeToHHMMSS(oldTimeStamp),
    appointment_mode:
      details?.extension?.find((x) => x?.url === 'appointmentMode')?.valueString === 'In-Person'
        ? 'in-person consultation'
        : 'video consultation',
    booking_id: details?.extension?.find((x) => x?.url === 'hisSystem')?.valueIdentifier?.value,
    booking_type: details?.extension?.find((x) => x?.url === 'isInstantGPAppointment')?.valueBoolean
      ? 'instant gp booking'
      : 'standard booking',
    doctor_name: screenName,
    speciality: practitionerDetails?.actor?.extension?.find((itm) => itm?.url === 'practitionerDepartment')
      ?.valueString,
    distance: locationDetails?.actor?.extension?.find((itm) => itm?.url === 'distance')?.valueString,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    new_appointment_date: formatDateToYearMonthDate(data?.start),
    new_appointment_time: convertTimeToHHMMSS(newTimeStamp),
  };
  dataLayerSendEvent('reschedule_appointment', itemData);
  sendSmRescheduleAppointment('reschedule_appointment', itemData);
};

export const rebookAppointmentList = (details, tabName) => {
  const facilityType = details?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString;
  const getFacilityType = () => {
    return facilityType === 'clinic' ? 'clinic_lt' : facilityType === 'hospital' ? 'hospital' : null;
  };
  const getScreenName = () => {
    if (tabName === 'All') {
      return 'appointments all';
    } else if (tabName === 'In-Person') {
      return 'appointments in-person';
    } else if (tabName === 'Video Consultation') {
      return 'appointments video';
    } else if (tabName === 'HOME') {
      return 'appointments homecare';
    } else {
      return 'appointments list';
    }
  };

  const itemData = {
    screen_name: getScreenName(),
    page_type: PAGE_NAME?.AP,
    speciality: details?.doctorType,
    appointment_mode: details?.consultType?.toLowerCase(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    doctor_name: details?.doctorName,
    facility_type: getFacilityType(),
    facility_name: details?.address,
  };
  dataLayerSendEvent('rebook_consultation_click', itemData);
  sendSmRebookConsultationClick('rebook_consultation_click', itemData);
};

export const rebookAppointmentDetail = (details) => {
  const getFacilityType = () => {
    return details?.facilityType === 'clinic' ? 'clinic_lt' : details?.facilityType === 'hospital' ? 'hospital' : null;
  };
  const itemData = {
    screen_name: SCREEN_NAME?.APPOINTMENT_DETAIL,
    page_type: PAGE_NAME?.AP,
    speciality: details?.doctorSpecialty,
    appointment_mode: details?.consultationType?.toLowerCase(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    doctor_name: details?.doctorName,
    facility_type: getFacilityType(),
    facility_name: details?.facilityName,
  };
  dataLayerSendEvent('rebook_consultation_click', itemData);
  sendSmRebookConsultationClick('rebook_consultation_click', itemData);
};

export const bookFollowUpList = (details, tabName, screenName, cdpCovered) => {
  const facilityType = details?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString;
  const getFacilityType = () => {
    return facilityType === 'clinic' ? 'clinic_lt' : facilityType === 'hospital' ? 'hospital' : null;
  };

  const getScreenName = () => {
    if (tabName === 'All') {
      return 'appointments all';
    } else if (tabName === 'In-Person') {
      return 'appointments in-person';
    } else if (tabName === 'Video Consultation') {
      return 'appointments video';
    } else if (tabName === 'HOME') {
      return 'appointments homecare';
    } else {
      return 'appointments list';
    }
  };

  const itemData = {
    screen_name: screenName ? screenName : getScreenName(),
    page_type: PAGE_NAME?.AP,
    facility_name: details?.address,
    facility_type: getFacilityType(),
    appointment_date: formatDateToYearMonthDate(details?.date),
    appointment_time: convertTimeToHHMMSS(details?.time),
    appointment_mode: details?.consultType?.toLowerCase(),
    appointment_id: details?.appointmentId,
    doctor_name: details?.doctorName,
    speciality: details?.doctorType,
    booking_id: details?.hisSystem?.valueIdentifier?.value,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    ...(cdpCovered ? { cdp_covered: cdpCovered } : {}),
  };
  dataLayerSendEvent('book_follow_up_click', itemData);
  sendSmBookFollowUpClick('book_follow_up_click', itemData);
};

export const bookFollowUpDetail = (details) => {
  const getFacilityType = () => {
    return details?.facilityType === 'clinic' ? 'clinic_lt' : details?.facilityType === 'hospital' ? 'hospital' : null;
  };

  const itemData = {
    screen_name: SCREEN_NAME?.APPOINTMENT_DETAIL,
    page_type: PAGE_NAME?.AP,
    facility_name: details?.facilityName,
    facility_type: getFacilityType(),
    appointment_date: formatDateToYearMonthDate(details?.appointmentDate),
    appointment_time: convertTimeToHHMMSS(details?.appointmentTime),
    appointment_mode: details?.consultationType?.toLowerCase(),
    appointment_id: details?.bookingConfirmationId,
    doctor_name: details?.doctorName,
    speciality: details?.doctorSpecialty,
    booking_id: details?.bookingID,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('book_follow_up_click', itemData);
  sendSmBookFollowUpClick('book_follow_up_click', itemData);
};

export const changePatientInBooking = (screenName, pageType) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  }
  dataLayerSendEvent('change_patient', itemData);
};

export const addInsurance = (screenName, pageType, data) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    type: data?.length === 0 ? '' : 'new',
  };
  dataLayerSendEvent('add_insurance', itemData);
};

export const addInsuranceError = (screenName, pageType, appointmentMode = '', error, errorType, data, option) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    appointment_mode: appointmentMode,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    error: error,
    err_type: errorType,
    type: data?.length === 0 ? '' : 'new',
    option: option,
  };
  dataLayerSendEvent('add_insurance_error', itemData);
};

export const addInsuranceSuccess = (screenName, pageType, option, data, response) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    option: option,
    type: data?.length === 0 ? '' : 'new',
    insurance_provider: response?.payor?.[0]?.display || '-',
    insurance_network: '',
  };
  dataLayerSendEvent('add_insurance_success', itemData);
};

export const selectInsuranceInBooking = (details) => {
  const itemData = {
    screen_name: SCREEN_NAME?.APPOINTMENT_CHECKOUT,
    page_type: PAGE_NAME?.CP,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    insurance_provider: details?.resource?.policyHolder?.display,
    insurance_network: details?.resource?.class?.find(item => item?.type?.coding?.find(coding => coding?.code === 'PlanCode'))?.name || '',
    insurance_coverage: details?.resource?.extension?.find((x) => x?.url === 'isInsuranceCovered')?.valueBoolean,
  };
  dataLayerSendEvent('select_insurance', itemData);
};

export const clickPayNow = (screenName, pageType, appointmentMode, details) => {
  const getBookingType = (details) => {
    if (details?.isInstantGPAppointment) {
      return 'instant gp booking';
    } else {
      return 'standard booking';
    }
  };

  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    appointment_mode: appointmentMode,
    booking_type: getBookingType(details),
  };
  dataLayerSendEvent('pay_now', itemData);
};

export const enterWaitingRoom = (screenName, pageType, details, appointmentDate, appointmentTime, appointmentId, cdpCovered) => {
  const getBookingType = (details) => {
    if (details?.isInstantGPAppointment) {
      return 'instant gp booking';
    } else {
      return 'standard booking';
    }
  };

  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    booking_type: getBookingType(details),
    booking_id: details?.hisSystem?.valueIdentifier?.value,
    facility_name: details?.facilityName,
    facility_type: details?.facilityType,
    appointment_time: convertTimeToHHMMSS(appointmentTime),
    appointment_date: formatDateToYearMonthDate(appointmentDate),
    appointment_id: appointmentId,
    ...(cdpCovered ? { cdp_covered: cdpCovered } : {}),
  };
  dataLayerSendEvent('enter_waiting_room', itemData);
};

export const enterWaitingRoomError = (screenName, pageType, details) => {
  const getBookingType = (details) => {
    if (details?.isInstantGPAppointment) {
      return 'instant gp booking';
    } else {
      return 'standard booking';
    }
  };

  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    booking_type: getBookingType(details),
    booking_id: details?.hisSystem?.valueIdentifier?.value,
    facility_name: details?.location?.actor?.display,
    facility_type: details?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    error: 'something went wrong',
    appointment_time: moment(details?.startTime).format('HH:mm:ss'),
    appointment_date: convertDateToServer(details?.startTime),
    appointment_id: details?.appointmentId,
  };
  dataLayerSendEvent('enter_waiting_room_error', itemData);
};

export const uploadDocumentsInBooking = (type, cdmProps, cdpCovered) => {
  const itemData = {
    screen_name: SCREEN_NAME?.WAITING_ROOM,
    page_type: PAGE_NAME?.WAITING_ROOM,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    document_type: type,
    cdp_covered: cdpCovered?.toString(),
    cdp_user_type: cdmProps?.newCdmPatient ? 'New' : 'Existing',
    cdp_type: cdmProps?.diagnoses,
  };
  dataLayerSendEvent('upload_documents', itemData);
};

export const uploadDocumentsErrorInBooking = (type, error, cdmProps, cdpCovered) => {
  const itemData = {
    screen_name: SCREEN_NAME?.WAITING_ROOM,
    page_type: PAGE_NAME?.WAITING_ROOM,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    document_type: type,
    error: error,
    cdp_covered: cdpCovered?.toString(),
    cdp_user_type: cdmProps?.newCdmPatient ? 'New' : 'Existing',
    cdp_type: cdmProps?.diagnoses,
  };
  dataLayerSendEvent('upload_documents_error', itemData);
};

export const enterVitalSignsInBooking = (details, cdmProps) => {

  const getBookingType = (details) => {
    if (details?.isInstantGPAppointment) {
      return 'instant gp booking';
    } else {
      return 'standard booking';
    }
  };

  const itemData = {
    screen_name: SCREEN_NAME?.WAITING_ROOM,
    page_type : PAGE_NAME?.WAITING_ROOM,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    facility_name: details?.location?.actor?.display,
    facility_type: details?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    speciality: details?.doctorSpecialization,
    doctor_name: details?.doctorData?.actor?.display,
    booking_type: getBookingType(details),
    appointment_time: moment(details?.startTime).format('HH:mm:ss'),
    appointment_date: convertDateToServer(details?.startTime),
    cdp_covered: details?.isCDP?.toString(),
    cdp_user_type: cdmProps?.newCdmPatient ? 'New' : 'Existing',
    cdp_type: cdmProps?.diagnoses,
  };
  dataLayerSendEvent('enter_vital_signs', itemData);
};

export const enterVitalSignsSuccessInBooking = (details, cdmProps) => {
  const getBookingType = (details) => {
    if (details?.isInstantGPAppointment) {
      return 'instant gp booking';
    } else {
      return 'standard booking';
    }
  };

  const itemData = {
    screen_name: SCREEN_NAME?.WAITING_ROOM,
    page_type : PAGE_NAME?.WAITING_ROOM,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    facility_name: details?.location?.actor?.display,
    facility_type: details?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    speciality: details?.doctorSpecialization,
    doctor_name: details?.doctorData?.actor?.display,
    booking_type: getBookingType(details),
    appointment_time: moment(details?.startTime).format('HH:mm:ss'),
    appointment_date: convertDateToServer(details?.startTime),
    cdp_covered: details?.isCDP?.toString(),
    cdp_user_type: cdmProps?.newCdmPatient ? 'New' : 'Existing',
    cdp_type: cdmProps?.diagnoses,
  };
  dataLayerSendEvent('enter_vital_signs_success', itemData);
};

export const vitalSignsReviewInBooking = (details, cdmProps) => {
  const getBookingType = (details) => {
    if (details?.isInstantGPAppointment) {
      return 'instant gp booking';
    } else {
      return 'standard booking';
    }
  };

  const itemData = {
    screen_name: SCREEN_NAME?.WAITING_ROOM,
    page_type : PAGE_NAME?.WAITING_ROOM,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    facility_name: details?.location?.actor?.display,
    facility_type: details?.location?.actor?.extension?.find((itm) => itm?.url === 'facilityType')?.valueString,
    speciality: details?.doctorSpecialization,
    doctor_name: details?.doctorData?.actor?.display,
    booking_type: getBookingType(details),
    appointment_time: moment(details?.startTime).format('HH:mm:ss'),
    appointment_date: convertDateToServer(details?.startTime),
    cdp_covered: details?.isCDP?.toString(),
    cdp_user_type: cdmProps?.newCdmPatient ? 'New' : 'Existing',
    cdp_type: cdmProps?.diagnoses,
  };
  dataLayerSendEvent('vital_signs_reviews', itemData);
};

export const notificationToggle = (option, selection) => {
  const itemData = {
    screen_name: 'main settings',
    page_type: 'profile page',
    option: option,
    selection: selection,
  };
  dataLayerSendEvent('notification_toggle', itemData);
};

export const dropDownSelectionEvent = (screenName, pageType, option, tabName) => {
  const itemData = {
    screen_name: screenName,
    page_type: pageType,
    option: option,
    tab_name: tabName,
  };
  dataLayerSendEvent('dropdown_selection', itemData);
};

export const recordsRevampSyncEvents = ({ eventName, screenName, tabName, error }) => {

  const itemData = {
    screen_name: screenName,
    page_type: PAGE_NAME?.RECORDS,
    tab_name: tabName,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };

  if (error) {
    itemData.error = error;
  }
  dataLayerSendEvent(eventName, itemData);
};

export const noRevampRecordsFound = (screenName, tabName, sync) => {

  const itemData = {
    screen_name: screenName,
    page_type: PAGE_NAME?.RECORDS,
    tab_name: tabName,
    type: sync,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('no_records_found', itemData);
};

export const revampViewRecord = (key, details) => {

  const getScreenName = (key) => {
    if (key === 'prescription') {
      return 'records prescription';
    } else if ( key === 'lab') {
      return 'records lab';
    } else if ( key === 'scan') {
      return 'records scan';
    } else if ( key === 'all') {
      return 'records all';
    }
  };

  const getTabName = (key) => {
    if (key === 'prescription') {
      return 'prescriptions';
    } else if (key === 'lab') {
      return 'lab reports';
    } else if (key === 'scan') {
      return 'scan reports';
    } else if (key === 'all'){
      return 'all';
    }
  };

  const getType = () => {
    if (details?.viewed) {
      return 'read';
    } else {
      return 'unread';
    }
  };

  const getReportName = () => {
    if (details?.resourceType === 'Prescription') {
      const names = [details?.medicineNames, details?.nonMedicineNames].filter(Boolean).join(', ');
      return names || null;
    }
    
    if (details?.resourceType === 'Lab Report') {
      return details?.labTests || null;
    }
  };

  const itemData = {
    screen_name: getScreenName(key),
    page_type: PAGE_NAME?.RECORDS,
    tab_name: getTabName(key),
    record_type: details?.resourceType,
    facility_name: details?.facilityName,
    appointment_mode: details?.appointmentType?.toLowerCase(),
    appointment_id: details?.appointmentId,
    speciality: details?.doctorDetail?.specialization,
    doctor_name: details?.doctorDetail?.doctorName,
    report_name: getReportName(),
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
    cdp_covered: details?.cdp,
    type: getType(),
  };

  dataLayerSendEvent('view_record', itemData);
};

export const newRecordAvailable = (screenName, tabName, type) => {

  const itemData = {
    screen_name: screenName,
    tab_name: tabName,
    page_type: PAGE_NAME?.RECORDS,
    type: type,
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('records_notification_interaction', itemData);
};

export const recordRevampPageView = (screenName, tabName) => {
  const itemData = {
    screen_name: screenName,
    tab_name: tabName,
    page_type: PAGE_NAME?.RECORDS,
    is_report_in_progress: 'false',
    myaster_category: MY_ASTER_CATEGORY?.DOCTOR_CONSULT,
  };
  dataLayerSendEvent('page_view', itemData);
};